export type AuthType = 'department' | 'repository' | 'document';
export type AuthOriginValue = string|number|null;

export type DepartmentRoleName = 'Member' |'Admin' | 'AAOwner';
export type RepositoryRoleName = 'Reader' | 'Member' | 'Admin' | 'AAOwner';
export type DocumentRoleName = 'DocReader' | 'DocMember' | 'DocAdmin';
export type AllRoleName = DepartmentRoleName | RepositoryRoleName | DocumentRoleName;

export interface AuthItem {
    type: AuthType;
    keyName?: string; // 不传即为roleName
    requestAuth: AuthOriginValue;
    strictEqual?: boolean; // 不传即为false
    negative?: boolean;
}

export interface ErrorItem {
    type: AuthType;
    requestCode: number|string;
}

export interface AuthFnParams {
    authValue?: any;
    authValues?: any[];
    originValue?: any;
    originValues?: any[];
    otherMapAuths?: any[];
    errorValue?: any;
}

export const ROLE = {
    Reader: 'Reader',
    Member: 'Member',
    Admin: 'Admin',
    AAOwner: 'AAOwner',
    DocReader: 'DocReader',
    DocMember: 'DocMember',
    DocAdmin: 'DocAdmin',
};

export const DOC_SCOPE_TYPE = {
    private: 20,
    publicRead: 5,
    publicEdit: 6,
};

// 私密（20）受限（12）公开（11）
export const REPO_SCOPE_TYPE = {
    private: 20,
    limited: 12,
    public: 11,
};

export const BOOK_TYPE = {
    NO_BOOK: 1, // 不在知识本内
    IS_BOOK: 2, // 知识本
    IN_BOOK: 3, // 在知识本内
};

export type {
    AuthObjType,
    AuthMapType,
    AuthDocumentKey,
    AuthRepositoryKey,
    AuthDepartmentKey,
    AuthDocumentResult,
    AuthRepositoryResult,
    AuthDepartmentResult,
    AuthResultType,
} from './KuAuthMap';
